import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import "../../css/styles.css";
import {
    Grid,
    Snackbar,
    Alert
} from "@mui/material";
import { getCierreMesBroker } from "../../action";
import FiltroCierreMensual from "./FiltroCierreMensual";
import TablaCierreMensual from "./TablaCierreMensual";

const IndexCierreMensual = () => {
    const dispatch = useDispatch();
    const history = useHistory();
    const [cierreAtrasados, setCierreAtrasados] = useState([]);
    const [loading, setLoading] = useState(true);

    const [snackbar, setSnackbar] = useState({
        open: false,
        message: "",
        severity: "info",
    });

    const handleCloseSnackbar = () => {
        setSnackbar((prev) => ({ ...prev, open: false }));
    };

    const showMessage = (msg, sev = "info") => {
        setSnackbar({ open: true, message: msg, severity: sev });
    };

    const [filtroMes, setFiltroMes] = useState("");
    const [filtroVersion, setFiltroVersion] = useState("");

    const [orderBy, setOrderBy] = useState("");
    const [orderDirection, setOrderDirection] = useState("asc");

    const fetchCierres = async () => {
        setLoading(true);
        try {
            const data = await dispatch(getCierreMesBroker(filtroMes));
            if (data && Array.isArray(data)) {
                setCierreAtrasados(data);
            } else if (data && data.value) {
                setCierreAtrasados(data.value);
            } else if (data && data.data) {
                setCierreAtrasados(data.data);
            } else {
                setCierreAtrasados([]);
            }
        } catch (error) {
            console.error("Error cargando cierres", error);
            showMessage("No se pudieron cargar los datos de cierre.", "error");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchCierres();
    }, [filtroMes]);

    const handleCargarCierre = () => {
        history.push("/cierre-mensual/cargar");
    };

    const handleSort = (property) => {
        const isAsc = orderBy === property && orderDirection === "asc";
        setOrderDirection(isAsc ? "desc" : "asc");
        setOrderBy(property);
    };

    const sortedAndFilteredData = React.useMemo(() => {
        let result = [...cierreAtrasados];

        if (filtroVersion) {
            result = result.filter(row =>
                String(row.version || row.versionMes || "").toLowerCase().includes(filtroVersion.toLowerCase())
            );
        }

        if (orderBy) {
            result.sort((a, b) => {
                const getValue = (obj, key) => {
                    switch (key) {
                        case 'versionMes': return obj.version || obj.versionMes || 0;
                        case 'mes': return obj.mes || "";
                        case 'nombreBroker': return obj.nombre_Broker || obj.nombreBroker || "";
                        case 'correo': return obj.Correo || obj.correo || "";
                        case 'ingresoMes': return obj.ingreso_Mes || obj.ingresoMes || 0;
                        case 'ingresoTrimestral': return obj.Ingreso_Trimestral || obj.ingresoTrimestral || 0;
                        case 'nCierresMensual': return obj.n_Cierres_Mensual || obj.nCierresMensual || 0;
                        case 'nCierresAnual': return obj.n_Cierres_Anual || obj.nCierresAnual || 0;
                        case 'metaTrimestral': return obj.meta_Trimestral || obj.metaTrimestral || 0;
                        case 'metaAnual': return obj.meta_Anual || obj.metaAnual || 0;
                        case 'visualizacionesPropiedades': return obj.visualizaciones_Propiedades || obj.visualizacionesPropiedades || 0;
                        case 'nStocks': return obj.n_Stocks || obj.nStocks || 0;
                        case 'ingresoAnual': return obj.ingreso_Anual || obj.ingresoAnual || 0;
                        default: return obj[key] !== undefined ? obj[key] : "";
                    }
                };

                let valA = getValue(a, orderBy);
                let valB = getValue(b, orderBy);

                if (!isNaN(valA) && !isNaN(valB)) {
                    valA = Number(valA);
                    valB = Number(valB);
                } else if (typeof valA === 'string' && typeof valB === 'string') {
                    valA = valA.toLowerCase();
                    valB = valB.toLowerCase();
                    return orderDirection === "asc" ? valA.localeCompare(valB) : valB.localeCompare(valA);
                }

                if (valA < valB) {
                    return orderDirection === "asc" ? -1 : 1;
                }
                if (valA > valB) {
                    return orderDirection === "asc" ? 1 : -1;
                }
                return 0;
            });
        }

        return result;
    }, [cierreAtrasados, filtroVersion, orderBy, orderDirection]);

    return (
        <div className="contenido" style={{ minWidth: 0, width: '100%' }}>
            <div className="header">
                <h2>Cierres Mensuales Brokers</h2>
            </div>

            <Grid container spacing={2} sx={{ mt: 2, mb: 2 }} justifyContent={"space-between"} alignItems="center">
                <Grid item xs={12} sm={4} md={3} lg={3} xl={3} className="alignLeft">
                    <button
                        className="boton"
                        onClick={handleCargarCierre}
                    >
                        Cargar Cierre
                    </button>
                </Grid>

                <FiltroCierreMensual
                    filtroMes={filtroMes}
                    setFiltroMes={setFiltroMes}
                    filtroVersion={filtroVersion}
                    setFiltroVersion={setFiltroVersion}
                />
            </Grid>

            <TablaCierreMensual
                loading={loading}
                data={sortedAndFilteredData}
                orderBy={orderBy}
                orderDirection={orderDirection}
                handleSort={handleSort}
            />

            <Snackbar
                open={snackbar.open}
                autoHideDuration={6000}
                onClose={handleCloseSnackbar}
                anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            >
                <Alert onClose={handleCloseSnackbar} severity={snackbar.severity} sx={{ width: "100%" }}>
                    {snackbar.message}
                </Alert>
            </Snackbar>
        </div>
    );
};

export default IndexCierreMensual;
